"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("~/utils/globals");
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _Filter = /*#__PURE__*/ _interop_require_default(require("~/models/Filter"));
const _Base = /*#__PURE__*/ _interop_require_default(require("~/models/Base"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// as of 0.104.3, almost all filter operators are available to all column types
// while some of them aren't supposed to be shown
// this upgrader is to remove those unsupported filters / migrate to the correct filter
// Change Summary:
// - Text-based columns:
//     - remove `>`, `<`, `>=`, `<=`
//     - Numeric-based / SingleSelect columns:
//     - remove `like`
//     - migrate `null`, and `empty` to `blank`
// - Checkbox columns:
//     - remove `equal`
//     - migrate `empty` and `null` to `notchecked`
// - MultiSelect columns:
//     - remove `like`
//     - migrate `equal`, `null`, `empty`
//     - Attachment columns:
//     - remove `>`, `<`, `>=`, `<=`, `equal`
//     - migrate `empty`, `null` to `blank`
// - LTAR columns:
//     - remove `>`, `<`, `>=`, `<=`
//     - migrate `empty`, `null` to `blank`
// - Lookup columns:
//     - migrate `empty`, `null` to `blank`
// - Duration columns:
//     - remove  `like`
//     - migrate `empty`, `null` to `blank`
const removeEqualFilters = (filter, ncMeta)=>{
    const actions = [];
    // remove `is equal`, `is not equal`
    if ([
        'eq',
        'neq'
    ].includes(filter.comparison_op)) {
        actions.push(_Filter.default.delete(filter.id, ncMeta));
    }
    return actions;
};
const removeArithmeticFilters = (filter, ncMeta)=>{
    const actions = [];
    // remove `>`, `<`, `>=`, `<=`
    if ([
        'gt',
        'lt',
        'gte',
        'lte'
    ].includes(filter.comparison_op)) {
        actions.push(_Filter.default.delete(filter.id, ncMeta));
    }
    return actions;
};
const removeLikeFilters = (filter, ncMeta)=>{
    const actions = [];
    // remove `is like`, `is not like`
    if ([
        'like',
        'nlike'
    ].includes(filter.comparison_op)) {
        actions.push(_Filter.default.delete(filter.id, ncMeta));
    }
    return actions;
};
const migrateNullAndEmptyToBlankFilters = (filter, ncMeta)=>{
    const actions = [];
    if ([
        'empty',
        'null'
    ].includes(filter.comparison_op)) {
        // migrate to blank
        actions.push(_Filter.default.update(filter.id, {
            comparison_op: 'blank'
        }, ncMeta));
    } else if ([
        'notempty',
        'notnull'
    ].includes(filter.comparison_op)) {
        // migrate to not blank
        actions.push(_Filter.default.update(filter.id, {
            comparison_op: 'notblank'
        }, ncMeta));
    }
    return actions;
};
const migrateMultiSelectEq = async (context, filter, col, ncMeta)=>{
    // only allow eq / neq
    if (![
        'eq',
        'neq'
    ].includes(filter.comparison_op)) return;
    // if there is no value -> delete this filter
    if (!filter.value) {
        return await _Filter.default.delete(filter.id, ncMeta);
    }
    // options inputted from users
    const options = filter.value.split(',');
    // retrieve the possible col options
    const colOptions = await col.getColOptions(context);
    // only include valid options as the input value becomes dropdown type now
    const validOptions = [];
    for (const option of options){
        if (colOptions.options.includes(option)) {
            validOptions.push(option);
        }
    }
    const newFilterValue = validOptions.join(',');
    // if all inputted options are invalid -> delete this filter
    if (!newFilterValue) {
        return await _Filter.default.delete(filter.id, ncMeta);
    }
    const actions = [];
    if (filter.comparison_op === 'eq') {
        // migrate to `contains all of`
        actions.push(_Filter.default.update(filter.id, {
            comparison_op: 'anyof',
            value: newFilterValue
        }, ncMeta));
    } else if (filter.comparison_op === 'neq') {
        // migrate to `doesn't contain all of`
        actions.push(_Filter.default.update(filter.id, {
            comparison_op: 'nanyof',
            value: newFilterValue
        }, ncMeta));
    }
    return await Promise.all(actions);
};
const migrateToCheckboxFilter = (filter, ncMeta)=>{
    const actions = [];
    const possibleTrueValues = [
        'true',
        'True',
        '1',
        'T',
        'Y'
    ];
    const possibleFalseValues = [
        'false',
        'False',
        '0',
        'F',
        'N'
    ];
    if ([
        'empty',
        'null'
    ].includes(filter.comparison_op)) {
        // migrate to not checked
        actions.push(_Filter.default.update(filter.id, {
            comparison_op: 'notchecked'
        }, ncMeta));
    } else if ([
        'notempty',
        'notnull'
    ].includes(filter.comparison_op)) {
        //  migrate to checked
        actions.push(_Filter.default.update(filter.id, {
            comparison_op: 'checked'
        }, ncMeta));
    } else if (filter.comparison_op === 'eq') {
        if (possibleTrueValues.includes(filter.value)) {
            // migrate to checked
            actions.push(_Filter.default.update(filter.id, {
                comparison_op: 'checked',
                value: ''
            }, ncMeta));
        } else if (possibleFalseValues.includes(filter.value)) {
            // migrate to notchecked
            actions.push(_Filter.default.update(filter.id, {
                comparison_op: 'notchecked',
                value: ''
            }, ncMeta));
        } else {
            // invalid value - good to delete
            actions.push(_Filter.default.delete(filter.id, ncMeta));
        }
    } else if (filter.comparison_op === 'neq') {
        if (possibleFalseValues.includes(filter.value)) {
            // migrate to checked
            actions.push(_Filter.default.update(filter.id, {
                comparison_op: 'checked',
                value: ''
            }, ncMeta));
        } else if (possibleTrueValues.includes(filter.value)) {
            // migrate to not checked
            actions.push(_Filter.default.update(filter.id, {
                comparison_op: 'notchecked',
                value: ''
            }, ncMeta));
        } else {
            // invalid value - good to delete
            actions.push(_Filter.default.delete(filter.id, ncMeta));
        }
    }
    return actions;
};
async function migrateFilters(ncMeta) {
    const filters = await ncMeta.knexConnection(_globals.MetaTable.FILTER_EXP);
    for (const filter of filters){
        if (!filter.fk_column_id || filter.is_group) {
            continue;
        }
        const context = {
            workspace_id: filter.fk_workspace_id,
            base_id: filter.fk_base_id
        };
        const col = await _Column.default.get(context, {
            colId: filter.fk_column_id
        }, ncMeta);
        if ([
            _nocodbsdk.UITypes.SingleLineText,
            _nocodbsdk.UITypes.LongText,
            _nocodbsdk.UITypes.PhoneNumber,
            _nocodbsdk.UITypes.Email,
            _nocodbsdk.UITypes.URL
        ].includes(col.uidt)) {
            await Promise.all(removeArithmeticFilters(filter, ncMeta));
        } else if ([
            // numeric fields
            _nocodbsdk.UITypes.Duration,
            _nocodbsdk.UITypes.Currency,
            _nocodbsdk.UITypes.Percent,
            _nocodbsdk.UITypes.Number,
            _nocodbsdk.UITypes.Decimal,
            _nocodbsdk.UITypes.Rating,
            _nocodbsdk.UITypes.Rollup,
            // select fields
            _nocodbsdk.UITypes.SingleSelect
        ].includes(col.uidt)) {
            await Promise.all([
                ...removeLikeFilters(filter, ncMeta),
                ...migrateNullAndEmptyToBlankFilters(filter, ncMeta)
            ]);
        } else if (col.uidt === _nocodbsdk.UITypes.Checkbox) {
            await Promise.all(migrateToCheckboxFilter(filter, ncMeta));
        } else if (col.uidt === _nocodbsdk.UITypes.MultiSelect) {
            await Promise.all([
                ...removeLikeFilters(filter, ncMeta),
                ...migrateNullAndEmptyToBlankFilters(filter, ncMeta)
            ]);
            await migrateMultiSelectEq(context, filter, col, ncMeta);
        } else if (col.uidt === _nocodbsdk.UITypes.Attachment) {
            await Promise.all([
                ...removeArithmeticFilters(filter, ncMeta),
                ...removeEqualFilters(filter, ncMeta),
                ...migrateNullAndEmptyToBlankFilters(filter, ncMeta)
            ]);
        } else if (col.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord) {
            await Promise.all([
                ...removeArithmeticFilters(filter, ncMeta),
                ...migrateNullAndEmptyToBlankFilters(filter, ncMeta)
            ]);
        } else if (col.uidt === _nocodbsdk.UITypes.Lookup) {
            await Promise.all([
                ...removeArithmeticFilters(filter, ncMeta),
                ...migrateNullAndEmptyToBlankFilters(filter, ncMeta)
            ]);
        } else if (col.uidt === _nocodbsdk.UITypes.Duration) {
            await Promise.all([
                ...removeLikeFilters(filter, ncMeta),
                ...migrateNullAndEmptyToBlankFilters(filter, ncMeta)
            ]);
        }
    }
}
async function updateProjectMeta(ncMeta) {
    const baseHasEmptyOrFilters = {};
    const filters = await ncMeta.knexConnection(_globals.MetaTable.FILTER_EXP);
    const actions = [];
    for (const filter of filters){
        if ([
            'notempty',
            'notnull',
            'empty',
            'null'
        ].includes(filter.comparison_op)) {
            baseHasEmptyOrFilters[filter.base_id] = true;
        }
    }
    const bases = await ncMeta.knexConnection(_globals.MetaTable.PROJECT);
    const defaultProjectMeta = {
        showNullAndEmptyInFilter: false
    };
    for (const base of bases){
        var _baseHasEmptyOrFilters_base_id;
        const oldProjectMeta = base.meta;
        let newProjectMeta = defaultProjectMeta;
        try {
            var _ref;
            newProjectMeta = (_ref = typeof oldProjectMeta === 'string' ? JSON.parse(oldProjectMeta) : oldProjectMeta) != null ? _ref : defaultProjectMeta;
        } catch (unused) {}
        newProjectMeta = _extends({}, newProjectMeta, {
            showNullAndEmptyInFilter: (_baseHasEmptyOrFilters_base_id = baseHasEmptyOrFilters[base.id]) != null ? _baseHasEmptyOrFilters_base_id : false
        });
        actions.push(_Base.default.update({
            workspace_id: base.fk_workspace_id,
            base_id: base.id
        }, base.id, {
            meta: JSON.stringify(newProjectMeta)
        }, ncMeta));
    }
    await Promise.all(actions);
}
async function _default({ ncMeta }) {
    // fix the existing filter behaviours or
    // migrate `null` or `empty` filters to `blank`
    await migrateFilters(ncMeta);
    // enrich `showNullAndEmptyInFilter` in base meta
    // if there is empty / null filters in existing bases,
    // then set `showNullAndEmptyInFilter` to true
    // else set to false
    await updateProjectMeta(ncMeta);
}
